// import React from 'react'
// import { Route, Routes } from 'react-router-dom';
// import ProjectDetails from '../../Components/Projects/ProjectDetails';
// import ProjectDrawer from '../../Components/Projects/ProjectDrawer';
// import UploadPictures from '../../Components/Projects/UploadPictures';
// import AddProperty from '../../Components/Property/AddProperty';
// import PropertyDrawer from '../../Components/Property/PropertyDrawer';
// import Customers from '../Customers';
// import Investment from '../Investment';
// import MainDashboard from '../MainDashboard';
// import Projects from '../Projects';
// import Properties from '../Properties';
// import Savings from '../Savings';
// import Settings from '../Settings';
// import Users from '../Users';
// import AddLandListing from '../../Components/Property/AddLandListing';
// import Liquidate from '../Liquidate';
// import Withdrawer from '../Withdrawal';
// import Notification from '../Notification';
// import Transaction from '../Transaction';
// import AssestFunding from '../AssestFunding';
// import Dashboard from '.';
// import Logout from '../logout/index.jsx';
// import MainDetails from '../../Components/Customers/MainDetails.js';
// import Otp from '../Otp/index.js';
// import Wallet from '../Wallet/index.js';

// // const Logout = React.lazy(() => import('./Pages/logout/index.jsx'));

// function Routess() {

//   return (
//     <div>
//       {localStorage.getItem("userRole") === 'SUPER_ADMIN' ?
//         <Routes>
//           <Route path='/logout' element={<Logout />} />
//           {/* <Route path='/dashboard' element={<Dashboard />} /> */}

//           <Route path="/verification" element={<Otp />} />
//           <Route path='/all-users' element={<MainDetails />} />
//           <Route path='/dashboard' element={<MainDashboard />} />
//           <Route path='/wallet' element={<Wallet />} />
//           <Route path='/liquidate' element={<Liquidate />} />
//           <Route path='/notification' element={<Notification />} />
//           <Route path='/withdrawal' element={<Withdrawer />} />
//           <Route path='/investment/*' element={<Investment />} />
//           <Route path='/projects' element={<Projects />}>
//             <Route path='newproject' element={<ProjectDrawer />}>
//               <Route path='projectdetails' element={<ProjectDetails />} />
//               <Route path='pictures' element={<UploadPictures />} />
//             </Route>
//             {/* <Route path='active' element={<ActiveProject/>}/>
//             <Route path='pending' element={<PendingProject/>}/>
//             <Route path='complete' element={<CompletedProject/>}/> */}
//           </Route>
//           <Route path='/savings' element={<Savings />} />
//           <Route path='/properties' element={<Properties />}>
//             <Route path='newproperty' element={<PropertyDrawer />}>
//               <Route path='property' element={<AddProperty />} />
//               <Route path='land' element={<AddLandListing />} />
//             </Route>
//           </Route>
//           <Route path='/customers' element={<Customers />} />
//           <Route path='/users' element={<Users />} />
//           <Route path='/settings' element={<Settings />} />
//           <Route path='/transaction' element={<Transaction />} />
//           <Route path='/assests' element={<AssestFunding />} />
//         </Routes> :
//         localStorage.getItem("userRole") === 'OPERATION_MANAGER' ?
//           <Routes>
//             <Route path='/logout' element={<Logout />} />
//             <Route path='/dashboard' element={<MainDashboard />} />
//             <Route path='/liquidate' element={<Liquidate />} />
//             <Route path='/notification' element={<Notification />} />
//             <Route path='/withdrawal' element={<Withdrawer />} />
//             <Route path='/investment' element={<Investment />} />
//             <Route path='/projects' element={<Projects />}>
//               <Route path='newproject' element={<ProjectDrawer />}>
//                 <Route path='projectdetails' element={<ProjectDetails />} />
//                 <Route path='pictures' element={<UploadPictures />} />
//               </Route>
//               {/* <Route path='active' element={<ActiveProject/>}/>
//             <Route path='pending' element={<PendingProject/>}/>
//             <Route path='complete' element={<CompletedProject/>}/> */}
//             </Route>
//             <Route path='/savings' element={<Savings />} />
//             <Route path='/properties' element={<Properties />}>
//               <Route path='newproperty' element={<PropertyDrawer />}>
//                 <Route path='property' element={<AddProperty />} />
//                 <Route path='land' element={<AddLandListing />} />
//               </Route>
//             </Route>
//             <Route path='/customers' element={<Customers />} />
//             <Route path='/users' element={<Users />} />
//             <Route path='/settings' element={<Settings />} />
//             <Route path='/transaction' element={<Transaction />} />
//             <Route path='/assests' element={<AssestFunding />} />
//           </Routes> :
//           localStorage.getItem("userRole") === 'PROJECT_MANAGER' ?
//             <Routes>
//                         <Route path='/logout' element={<Logout />} />
//               <Route path='/dashboard' element={<MainDashboard />} />
//               <Route path='/liquidate' element={<Liquidate />} />
//               <Route path='/notification' element={<Notification />} />
//               <Route path='/withdrawal' element={<Withdrawer />} />
//               <Route path='/investment/*' element={<Investment />} />
//               <Route path='/projects' element={<Projects />}>
//                 <Route path='newproject' element={<ProjectDrawer />}>
//                   <Route path='projectdetails' element={<ProjectDetails />} />
//                   <Route path='pictures' element={<UploadPictures />} />
//                 </Route>
//                 {/* <Route path='active' element={<ActiveProject/>}/>
//             <Route path='pending' element={<PendingProject/>}/>
//             <Route path='complete' element={<CompletedProject/>}/> */}
//               </Route>
//               <Route path='/savings' element={<Savings />} />
//               <Route path='/properties' element={<Properties />}>
//                 <Route path='newproperty' element={<PropertyDrawer />}>
//                   <Route path='property' element={<AddProperty />} />
//                   <Route path='land' element={<AddLandListing />} />
//                 </Route>
//               </Route>
//               <Route path='/customers' element={<Customers />} />
//               <Route path='/users' element={<Users />} />
//               <Route path='/settings' element={<Settings />} />
//               <Route path='/transaction' element={<Transaction />} />
//               <Route path='/assests' element={<AssestFunding />} />
//             </Routes> :
//             localStorage.getItem("userRole") === 'FINANCE_MANAGER' ?
//               <Routes>
//                           <Route path='/logout' element={<Logout />} />
//                 <Route path='/dashboard' element={<MainDashboard />} />
//                 <Route path='/liquidate' element={<Liquidate />} />
//                 <Route path='/notification' element={<Notification />} />
//                 <Route path='/withdrawal' element={<Withdrawer />} />
//                 <Route path='/investment' element={<Investment />} />
//                 <Route path='/projects' element={<Projects />}>
//                   <Route path='newproject' element={<ProjectDrawer />}>
//                     <Route path='projectdetails' element={<ProjectDetails />} />
//                     <Route path='pictures' element={<UploadPictures />} />
//                   </Route>
//                   {/* <Route path='active' element={<ActiveProject/>}/>
//             <Route path='pending' element={<PendingProject/>}/>
//             <Route path='complete' element={<CompletedProject/>}/> */}
//                 </Route>
//                 <Route path='/savings' element={<Savings />} />
//                 <Route path='/properties' element={<Properties />}>
//                   <Route path='newproperty' element={<PropertyDrawer />}>
//                     <Route path='property' element={<AddProperty />} />
//                     <Route path='land' element={<AddLandListing />} />
//                   </Route>
//                 </Route>
//                 <Route path='/customers' element={<Customers />} />
//                 <Route path='/users' element={<Users />} />
//                 <Route path='/settings' element={<Settings />} />
//                 <Route path='/transaction' element={<Transaction />} />
//                 <Route path='/assests' element={<AssestFunding />} />
//               </Routes> :
//               localStorage.getItem("userRole") === 'OPERATOR' ?
//                 <Routes>
//                             <Route path='/logout' element={<Logout />} />
//                   <Route path='/dashboard' element={<MainDashboard />} />
//                   <Route path='/liquidate' element={<Liquidate />} />
//                   <Route path='/notification' element={<Notification />} />
//                   <Route path='/withdrawal' element={<Withdrawer />} />
//                   <Route path='/investment' element={<Investment />} />
//                   <Route path='/projects' element={<Projects />}>
//                     <Route path='newproject' element={<ProjectDrawer />}>
//                       <Route path='projectdetails' element={<ProjectDetails />} />
//                       <Route path='pictures' element={<UploadPictures />} />
//                     </Route>
//                     {/* <Route path='active' element={<ActiveProject/>}/>
//             <Route path='pending' element={<PendingProject/>}/>
//             <Route path='complete' element={<CompletedProject/>}/> */}
//                   </Route>
//                   <Route path='/savings' element={<Savings />} />
//                   <Route path='/properties' element={<Properties />}>
//                     <Route path='newproperty' element={<PropertyDrawer />}>
//                       <Route path='property' element={<AddProperty />} />
//                       <Route path='land' element={<AddLandListing />} />
//                     </Route>
//                   </Route>
//                   <Route path='/customers' element={<Customers />} />
//                   <Route path='/users' element={<Users />} />
//                   <Route path='/settings' element={<Settings />} />
//                   <Route path='/transaction' element={<Transaction />} />
//                   <Route path='/assests' element={<AssestFunding />} />
//                 </Routes> :
//                 <Routes>
//                   <Route path='/dashboard' element={<MainDashboard />} />
//                 </Routes>
//       }

//     </div>
//   )
// }

// export default Routess

import React from "react";
import { Route, Routes } from "react-router-dom";
import ProjectDetails from "../../Components/Projects/ProjectDetails";
import ProjectDrawer from "../../Components/Projects/ProjectDrawer";
import UploadPictures from "../../Components/Projects/UploadPictures";
import AddProperty from "../../Components/Property/AddProperty";
import PropertyDrawer from "../../Components/Property/PropertyDrawer";
import Customers from "../Customers";
import Investment from "../Investment";
import MainDashboard from "../MainDashboard";
import Projects from "../Projects";
import Properties from "../Properties";
import Savings from "../Savings";
import Settings from "../Settings";
import Users from "../Users";
import AddLandListing from "../../Components/Property/AddLandListing";
import Liquidate from "../Liquidate";
import Withdrawer from "../Withdrawal";
import Notification from "../Notification";
import Transaction from "../Transaction";
import AssestFunding from "../AssestFunding";
import Logout from "../logout/index.jsx";
import MainDetails from "../../Components/Customers/MainDetails.js";
import Otp from "../Otp/index.js";
import Wallet from "../Wallet/index.js";
import AssetFinancingRequestDetails from "../../Components/Assest/AssetFinancingRequestDetails.js";

// Shared nested route children — reused across roles
const ProjectRoutes = (
  <Route path="/projects" element={<Projects />}>
    <Route path="newproject" element={<ProjectDrawer />}>
      <Route path="projectdetails" element={<ProjectDetails />} />
      <Route path="pictures" element={<UploadPictures />} />
    </Route>
  </Route>
);

const PropertyRoutes = (
  <Route path="/properties" element={<Properties />}>
    <Route path="newproperty" element={<PropertyDrawer />}>
      <Route path="property" element={<AddProperty />} />
      <Route path="land" element={<AddLandListing />} />
    </Route>
  </Route>
);

const AssetFinancingRoutes = (
  <>
    <Route path="/assests/asset-requests/:requestId" element={<AssetFinancingRequestDetails />} />
    <Route path="/assests" element={<AssestFunding />} />
  </>
);

function Routess() {
  const userRole = localStorage.getItem("userRole");
  const isFullAccessAdmin = userRole === "SUPER_ADMIN" || userRole === "ADMIN";


  if (isFullAccessAdmin) {
    return (
      <Routes>
        <Route path="/logout" element={<Logout />} />
        <Route path="/verification" element={<Otp />} />
        <Route path="/all-users" element={<MainDetails />} />
        <Route path="/dashboard" element={<MainDashboard />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/liquidate" element={<Liquidate />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/withdrawal" element={<Withdrawer />} />
        <Route path="/investment/*" element={<Investment />} />
        {ProjectRoutes}
        <Route path="/savings" element={<Savings />} />
        {PropertyRoutes}
        <Route path="/customers" element={<Customers />} />
        <Route path="/users" element={<Users />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/transaction" element={<Transaction />} />
        {AssetFinancingRoutes}
      </Routes>
    );
  }


  if (userRole === "OPERATION_MANAGER") {
    return (
      <Routes>
        <Route path="/logout" element={<Logout />} />
        <Route path="/dashboard" element={<MainDashboard />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/withdrawal" element={<Withdrawer />} />
        <Route path="/investment/*" element={<Investment />} />
        <Route path="/wallet" element={<Wallet />} />
        {ProjectRoutes}
        <Route path="/savings" element={<Savings />} />
        {PropertyRoutes}
        <Route path="/customers" element={<Customers />} />
        <Route path="/users" element={<Users />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/transaction" element={<Transaction />} />
        {AssetFinancingRoutes}
      </Routes>
    );
  }

  if (userRole === "PROJECT_MANAGER") {
    return (
      <Routes>
        <Route path="/logout" element={<Logout />} />
        <Route path="/dashboard" element={<MainDashboard />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/withdrawal" element={<Withdrawer />} />
        <Route path="/investment/*" element={<Investment />} />
        {ProjectRoutes}
        <Route path="/savings" element={<Savings />} />
        {PropertyRoutes}
        <Route path="/customers" element={<Customers />} />
        <Route path="/users" element={<Users />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/transaction" element={<Transaction />} />
        {AssetFinancingRoutes}
      </Routes>
    );
  }

  if (userRole === "FINANCE_MANAGER") {
    return (
      <Routes>
        <Route path="/logout" element={<Logout />} />
        <Route path="/dashboard" element={<MainDashboard />} />
        <Route path="/liquidate" element={<Liquidate />} />
        <Route path="/investment/*" element={<Investment />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/withdrawal" element={<Withdrawer />} />
        <Route path="/savings" element={<Savings />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/users" element={<Users />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/transaction" element={<Transaction />} />
        {AssetFinancingRoutes}
      </Routes>
    );
  }

  // ─────────────────────────────────────────────
  // OPERATOR — not defined in backend roles yet,
  // giving minimal access until clarified
  // ─────────────────────────────────────────────
  if (userRole === "OPERATOR") {
    return (
      <Routes>
        <Route path="/logout" element={<Logout />} />
        <Route path="/dashboard" element={<MainDashboard />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/settings" element={<Settings />} />
        {AssetFinancingRoutes}
      </Routes>
    );
  }


  return (
    <Routes>
      <Route path="/dashboard" element={<MainDashboard />} />
    </Routes>
  );
}

export default Routess;
